import { useTranslation } from 'react-i18next';
import { Database } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import type { ConnectionChoiceItem } from './connectionsApi';

/** Kiracı (veritabanı) seçim listesi — kart başına firma + veritabanı adı. */
export function ConnectionPicker({
  items,
  value,
  onChange,
}: {
  items: ConnectionChoiceItem[];
  value: string | null;
  onChange: (item: ConnectionChoiceItem) => void;
}) {
  const { t } = useTranslation();
  return (
    <div role="radiogroup" aria-label={t('auth.connectionPicker.title')} className="flex flex-col gap-2">
      <p className="text-sm text-fg-muted">{t('auth.connectionPicker.hint')}</p>
      <div className="max-h-64 overflow-auto rounded-md border border-border">
        {items.map((c) => (
          <button
            key={c.connectionId}
            type="button"
            role="radio"
            aria-checked={c.connectionId === value}
            onClick={() => onChange(c)}
            className={cn(
              'flex w-full items-center gap-3 border-b border-border px-3 py-2 text-left last:border-b-0 hover:bg-bg-hover',
              c.connectionId === value && 'bg-brand-500/10',
            )}
          >
            <Database className="h-4 w-4 shrink-0 text-brand-600" />
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium">{c.customerName || c.name}</span>
              {c.customerName ? <span className="block truncate text-xs text-fg-muted">{c.name}</span> : null}
            </span>
            {c.showNumber ? <span className="text-xs text-fg-subtle">{c.showNumber}</span> : null}
          </button>
        ))}
      </div>
    </div>
  );
}
